import React from 'react';

const Loader: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    data-testid="Loader"
    role="img"
    width={410}
    height={38}
    aria-labelledby="loading-aria"
    viewBox="0 0 410 38"
    preserveAspectRatio="none"
  >
    <title id="loading-aria">Loading...</title>
    <rect
      x={0}
      y={0}
      width="100%"
      height="100%"
      clipPath="url(#clip-path)"
      style={{
        fill: 'url("#fill")',
      }}
    />
    <defs>
      <clipPath id="clip-path">
        <rect x={-133} y={5} rx={8} ry={8} width={410} height={21} />
      </clipPath>
      <linearGradient id="fill">
        <stop offset={0.599964} stopColor="#d6d6d6" stopOpacity={1}>
          <animate
            attributeName="offset"
            values="-2; -2; 1"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite"
          />
        </stop>
        <stop offset={1.59996} stopColor="#f2f2f2" stopOpacity={1}>
          <animate
            attributeName="offset"
            values="-1; -1; 2"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite"
          />
        </stop>
        <stop offset={2.59996} stopColor="#d6d6d6" stopOpacity={1}>
          <animate
            attributeName="offset"
            values="0; 0; 3"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite"
          />
        </stop>
      </linearGradient>
    </defs>
  </svg>
);

export default Loader;
